import PlatformService from 'modules/Platform';
import get from 'lodash/get';

function getDeviceDetails() {
  const { os, osVersion, device } = PlatformService.getDeviceDetails(true);
  const networkSpeed = get(window, 'navigator.connection.downlink', '');
  const networkType = get(window, 'navigator.connection.effectiveType', '');
  const { deviceMemory }: any = window?.navigator || {};

  return {
    Os: os,
    Browser: osVersion,
    Device: device,
    'Network Speed': networkSpeed,
    'Network Type': networkType,
    'Device Memory': deviceMemory,
  };
}

export default getDeviceDetails;
